import { FC } from 'react';

export type TPlatformLogoProps = {
	platform: string;
};

export const PlatformLogo: FC<TPlatformLogoProps> = ({ platform }) => {
	const src =
		platform.toLocaleLowerCase() === 'shopify'
			? `/img/platformLogo/shopify.png`
			: platform === 'woocommerce'
				? `/img/platformLogo/wooCommerce.png`
				: platform === 'wix'
					? `/img/platformLogo/wix.png`
					: platform === 'magento'
						? `/img/platformLogo/magento.png`
						: platform === 'bigcommerce'
							? `/img/platformLogo/bigcommerce.png`
							: platform === 'squarespace'
								? `/img/platformLogo/squarespace.png`
								: platform === 'square'
									? `/img/platformLogo/squarespace.png`
									: platform === 'prestashop'
										? `/img/platformLogo/prestashop.png`
										: platform === 'shopware'
											? `/img/platformLogo/shopware.png`
											: platform === 'shopware 5'
												? `/img/platformLogo/shopware.png`
												: platform === 'shopware 6'
													? `/img/platformLogo/shopware.png`
													: ``;
	if (src)
		return (
			<img
				src={src}
				alt={platform}
				style={{
					width: 'object-fit',
					height: '30px',
					objectFit: 'contain',
				}}
			/>
		);
	if (platform) return <p> {platform}</p>;
	return null;
};
